import { Injectable } from '@angular/core';
import {Config} from "../config/config";
import {HttpClient} from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  //http header
  httpPostOptions = {
    withCredentials: true
  };
  constructor(private config: Config,private _http:HttpClient) { }

  getCountries(){
    return this._http.get(this.config.restCountries,this.httpPostOptions)
      .toPromise()
  }
}
